import { readableBytesAsGB } from "../../utils/util";
import ImageWithFallback from "../../components/ImageWithFallback";


export const updateCardContent = (topCard, apiResponse, selectedIndexes) => {
  if (!topCard || !topCard.cardContent || !topCard.cardKeys) return topCard;

  const defaultNumberOfCards = parseInt(topCard.defaultNumberOfCards, 10) || topCard.cardContent.length;
  const indexesToShow = selectedIndexes.length 
    ? selectedIndexes 
    : topCard.cardContent.slice(0, defaultNumberOfCards).map((_, i) => i);

  return {
    ...topCard,
    cardContent: topCard.cardContent
      .map((card, index) => {
  if (!indexesToShow.includes(index)) return null;

  const key = Object.keys(card)[0];
  const cardData = card[key];
  if (!cardData) return null;

  const { leftValue, rightHeadingUnit, rightValue, rightUnit } = cardData;
  const { rightHeadingKey, rightkey, refKey, progressBarKey } = topCard.cardKeys[index];
  const updatedrightHeadingKey = refKey ? `${refKey}+${rightHeadingKey}` : rightHeadingKey;
  const updatedRightKey = refKey ? `${refKey}+${rightkey}` : rightkey;
  const individualUsage = apiResponse?.[updatedrightHeadingKey];
  const totalUsage = apiResponse?.total_usage;

  let progressPercentage;

  if (progressBarKey) {
    if (progressBarKey.includes("/")) {
      // Split numerator and denominator
      const [rawA, rawB] = progressBarKey.split("/").map((k) => k.trim());

      // Apply refKey only to numerator (A)
      const numeratorKey = refKey ? `${refKey}+${rawA}` : rawA;

      // Handle denominator: could be a single key or an expression like a + b
      let denominatorValue = 0;

      if (rawB.includes("+")) {
        // Example: "a + b"
        const parts = rawB.split("+").map((k) => k.trim());
        denominatorValue = parts.reduce((sum, part) => {
          const val = apiResponse?.[part] ?? 0;
          return sum + (typeof val === "number" ? val : 0);
        }, 0);
      } else {
        denominatorValue = apiResponse?.[rawB] ?? 0;
      }

      const numeratorValue = apiResponse?.[numeratorKey] ?? 0;

      if (denominatorValue > 0) {
        progressPercentage = Number(
          ((numeratorValue / denominatorValue) * 100).toFixed(2)
        );
      }
    } else {
      // Direct key (percentage already)
      const updatedKey = refKey
        ? `${refKey}+${progressBarKey}`
        : progressBarKey;
      const val = apiResponse?.[updatedKey];
      if (typeof val === "number" && !isNaN(val)) {
        progressPercentage = Number(val.toFixed(2));
      }
    }
  }

  let updatedrightHeadingValue = apiResponse?.[updatedrightHeadingKey] ?? leftValue;
  let updatedRightValue = apiResponse?.[updatedRightKey] ?? rightValue;

  if (rightkey.includes("/")) {
    const keys = rightkey.split(" / ").map((k) => k.trim());
    const updatedKeys = keys.map((k) => (refKey ? `${refKey}+${k}` : k));
    let values = updatedKeys.map((k) => apiResponse?.[k] ?? 0);
    let units = rightUnit ? rightUnit.split(" / ").map((u) => u.trim()) : ["", ""];
    values = values.map((val, i) =>
      units[i] === "GB" ? readableBytesAsGB(val, false) : val
    );
    updatedRightValue = values.map((val, i) => `${val} ${units[i]}`.trim()).join(" / ");
  }

  if (rightHeadingUnit === "GB" && typeof updatedrightHeadingValue === "number") {
    updatedrightHeadingValue = readableBytesAsGB(updatedrightHeadingValue, false);
  }

  if (!rightkey.includes("/") && rightUnit === "GB" && typeof updatedRightValue === "number") {
    updatedRightValue = readableBytesAsGB(updatedRightValue, false);
  }

  const formatValueWithUnit = (value, unit) => {
    if (typeof value === "number") {
      value = value % 1 !== 0 ? value.toFixed(2) : value;
    }
    return unit ? `${value} ${unit}`.trim() : value;
  };

  updatedrightHeadingValue = formatValueWithUnit(updatedrightHeadingValue, rightHeadingUnit);
  if (!rightkey.includes("/")) {
    updatedRightValue = formatValueWithUnit(updatedRightValue, rightUnit);
  }

  return {
    [key]: {
      ...cardData,
      leftValue: cardData.leftValue, 
      rightHeading: updatedrightHeadingValue,
      rightValue: updatedRightValue,
      percentage: progressPercentage,
    },
  };
})

      .filter(Boolean), // Remove null values (unselected cards)
  };
};

export const getInterval = (minutes) => {
  if (minutes <= 720) {
      return "5 minute";
  } else if (minutes > 720 && minutes <= 1440) {
      return "15 minute";
  } else if (minutes > 1440 && minutes <= 10080) {
      return "1 hour";
  } else {
      return "12 hour";
  }
}

export const getAvilWindow = (interval) => {
  switch (interval) {
    case "5 minute": return 1;
    case "10 minute": return 2;
    case "15 minute": return 3;
    case "30 minute": return 6;
    case "1 hour": return 12;
    case "2 hour": return 24;
    case "3 hour": return 36;
    case "6 hour": return 72;
    case "12 hour": return 144;
    case "1 day": return 288;
    case "7 day": return 2016;
    case "30 day": return 8640;
    default: return 3;
  }
}

export const GetTopAppsImage = (props) => {
  const { app } = props;
  if(app) {
    let appName = app.includes(' ') ? app.split(' ')[0]: app.includes('-') ? app.split('-')[0] : ""; 
    return <ImageWithFallback src={`https://cdn.k4mobility.com/cdn/sportAssets/app_icons/${app.trim()}`} fallbackSrcs={[`https://cdn.k4mobility.com/cdn/sportAssets/app_icons/${appName.trim()}`,"https://cdn.k4mobility.com/cdn/sportAssets/fallbackImg.png"]} app={app} />
  } else {
    return <img className="logo-activity paddingLogo" src={`https://cdn.k4mobility.com/cdn/sportAssets/fallbackImg.png`} />
  }
}